import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCalls } from '../context/calls-context.jsx';
import { callsRequest } from '../hooks/calls-api.js';
import { callsOptions } from '../dto/calls.dto.js';
import { isActiveAttempt } from '../model/calls.model.js';

export default function CallsActions({ profileId, profileLabel, taskId, compact = false }) {
  const { t } = useTranslation();
  const calls = useCalls();
  const [ready, setReady] = useState({ scope: null, canDial: false });
  useEffect(() => {
    let live = true;
    if (calls.canDial) callsRequest(calls.token, '/options').then((payload) => {
      if (live) setReady({ scope: calls.token, ...callsOptions(payload) });
    }).catch(() => { if (live) setReady({ scope: calls.token, canDial: false }); });
    return () => { live = false; };
  }, [calls.canDial, calls.token, calls.revision]);
  if (!calls.canView || !profileId) return null;
  const canStart = calls.canDial && ready.scope === calls.token && ready.canDial;
  return <div className="d-flex flex-wrap align-items-center gap-2">
    {calls.canDial && <button type="button" className="btn btn-primary" disabled={!canStart || calls.starting || calls.active.some(isActiveAttempt)} onClick={() => calls.startCall(profileId, taskId)} title={!canStart ? t('calls.providerUnavailable') : undefined}>{t('calls.callNow')}</button>}
    {!compact && calls.canManage && <button type="button" className="btn btn-outline-primary" onClick={() => calls.openEditor('plan', { profileId, profileLabel })}>{t('calls.schedule')}</button>}
    {!compact && calls.canDial && !canStart && <span className="small text-muted">{t('calls.providerUnavailable')}</span>}
  </div>;
}
